import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import PhoneInputField from 'dashboard/components/FormControls/PhoneInputField';
import EmptyRow from 'dashboard/layouts/FormLayout/EmptyRow';
import Form from 'dashboard/layouts/FormLayout/Form';
import { User } from 'dashboard/models/user';
import Button from 'design-system/components/Button';
import { HStack } from 'design-system/components/Stack';
import { isRequired, isValidPhone, Rule, withMessage } from 'lib/utils/formValidation';

const validate: Record<keyof FormUserPhoneNumberData, Rule[]> = {
  'phone-number': [
    withMessage('The phone number you entered is not valid', isRequired),
    withMessage('The phone number you entered is not valid', isValidPhone),
  ],
};

interface FormUserPhoneNumberProps {
  onCancel: () => void;
}

const FormUserPhoneNumber = ({
  handleSubmit,
  submitting,
  pristine,
  onCancel,
}: InjectedFormProps & FormUserPhoneNumberProps) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Field
        component={PhoneInputField}
        name='phone-number'
        id='phone-number'
        type='text'
        data-test='form-user-phone-number__phone-number'
        disabled={submitting}
        placeholder='Phone number'
        validate={validate['phone-number']}
      />
      <EmptyRow />
      <HStack equal={true}>
        <Button
          variant='basic'
          id='form-user-phone-number__cancel'
          data-test='form-user-phone-number__cancel'
          disabled={submitting}
          isPending={submitting}
          onClick={onCancel}
        >
          Back
        </Button>
        <Button
          type='submit'
          id='form-user-phone-number__submit'
          data-test='form-user-phone-number__submit'
          disabled={submitting || pristine}
          isPending={submitting}
          onClick={handleSubmit}
        >
          Send code
        </Button>
      </HStack>
    </Form>
  );
};

export type FormUserPhoneNumberData = Pick<User['attributes'], 'phone-number'>;

export default reduxForm<FormUserPhoneNumberData, FormUserPhoneNumberProps>({
  form: 'formPhoneNumber',
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormUserPhoneNumber);
